import React from "react";
import { Form } from "@redriver/cinnamon";
import FormArrayDeleteModal from "features/../../../shared/components/forms/FormArrayDeleteModal";
import { useTranslation } from "react-i18next";
import {
  NonPropagatingEmail,
  NonPropagatingInput,
} from "features/../../../shared/components/forms/NonPropagatingField";

const UserArray = ({ field, onUserRemoved }) => {
  const { t } = useTranslation("agreements");
  return (
    <Form.Array field={field} arrayKey="id" propagateUpdates="always">
      {() => {
        return (
          <div className="user-list">
            <NonPropagatingInput
              label={t("SheetActions.SendForApproval.ViewBeforeSigned_Name")}
              field="name"
              required
            />
            <NonPropagatingEmail
              label={t("SheetActions.SendForApproval.ViewBeforeSigned_Email")}
              field="email"
              required
            />
            <NonPropagatingInput
              label={t(
                "SheetActions.SendForApproval.ViewBeforeSigned_PhoneNumber",
              )}
              field="phoneNumber"
              required
            />
            <NonPropagatingInput
              label={t(
                "SheetActions.SendForApproval.ViewBeforeSigned_PhoneCountryCode",
              )}
              field="phoneCountryCode"
              required
            />

            <FormArrayDeleteModal
              nameOfRemoval="User"
              onUserRemoved={onUserRemoved}
            />
          </div>
        );
      }}
    </Form.Array>
  );
};

export default UserArray;
